module.exports = __webpack_public_path__ + "img/harry_potter_02_and_the_chamber_of_secrets_scan.11c81fdc.jpg";